import React from 'react';
import { EmailCommsTemplateStatus, EmailCommsTemplateTeam } from '@scale/shared-types';
// eslint-disable-next-line restrict-imports/restrict-imports
import Select from 'corp/components/UI/Select';

interface SelectTagProps {
  value?: { label: string; value: string }[];
  onChange?: (e: any) => void;
  placeholder?: string;
  showTagId?: boolean;
  multi?: boolean;
}

export enum TemplatePlatformType {
  Outlier = 'Outlier AI',
  Remotasks = 'Remotasks',
}

const SelectTemplateTag: React.FC<SelectTagProps> = ({
  value,
  onChange,
  placeholder = 'Select a tag',
  showTagId = true,
  multi,
}) => {
  const fetchTags = async (_search: string) => {
    const templateStatusOptions = Object.values(EmailCommsTemplateStatus).map(type => ({
      label: type.toString(),
      value: type.toString(),
    }));

    const templateTeamOptions = Object.values(EmailCommsTemplateTeam).map(type => ({
      label: type.toString(),
      value: type.toString(),
    }));

    const templatePlatformOptions = Object.values(TemplatePlatformType).map(type => ({
      label: type.toString(),
      value: type.toString(),
    }));

    return {
      options: [...templatePlatformOptions, ...templateStatusOptions, ...templateTeamOptions],
    };
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      showTagId={showTagId}
      multi={multi}
      loadOptions={fetchTags}
      ignoreCase={true}
    />
  );
};

export default SelectTemplateTag;
